import { Injectable } from '@angular/core';
import { BarcodeStore } from './barcode.store';
import { Barcode } from './barcode.model';
import { MemberQuery } from '../member/member.query';
import { UserContext } from '../member/models/user-context.model';
import { ApiService } from '../../shared/services/core/api.service';
import { tap, mapTo } from 'rxjs/operators';
import { BarcodeQuery } from './barcode.query';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BarcodeService {
  constructor(
    private barcodeStore: BarcodeStore,
    private barcodeQuery: BarcodeQuery,
    private memberQuery: MemberQuery,
    private api: ApiService
  ) {}

  fetchBarcode() {
    let userContext = this.memberQuery.getValue().user as UserContext;
    if (this.barcodeQuery.getHasCache() && this.barcodeQuery.getValue().MemberId === userContext.memberId) {
      return of('from cache');
    }
    return this.api.getById<Barcode>('barcodes', userContext.memberId).pipe(
      tap(barcode => this.barcodeStore.update(barcode)),
      mapTo('from server')
    );
  }
}
